/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Component for dynamic load on scroll
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.0.0
 */

import { PureComponent, ChangeEvent, RefObject } from 'react';

import debounce from 'lodash/debounce';

class InfinityScrollWrapper extends PureComponent<IInfinityScrollWrapperProps> {
    componentDidMount(): void {
        if (this.props.watchDocumentBody) {
            document.addEventListener('scroll', this.onChangeScrollBodyDebounce as any);
        } else
            this.props.watchElement?.current?.addEventListener('scroll', this.onChangeScrollDebounce as any);
    }

    componentWillUnmount(): void {
        if (this.props.watchDocumentBody) {
            document.removeEventListener('scroll', this.onChangeScrollBodyDebounce as any);
        } else
            this.props.watchElement?.current?.removeEventListener('scroll', this.onChangeScrollDebounce as any);
    }

    onChangeScrollBody = (event: ChangeEvent<HTMLDivElement>): void => {
        if (this.props.isLoading || !this.props.hasMore) return;
        const el = document.body;
        const top = -document.body.getBoundingClientRect().top;
        const clientHeight = el.clientHeight;
        if (clientHeight - window.innerHeight - top < 200) {
            this.props.onScrollEvent(event);
        }
    };

    private onChangeScrollBodyDebounce = debounce(this.onChangeScrollBody, 250);

    onChangeScroll = (event: ChangeEvent<HTMLDivElement>): void => {
        if (this.props.isLoading || !this.props.hasMore) return;
        if (!this.props.sizeElement.current) return;
        const el = this.props.sizeElement.current;
        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;
        if (scrollHeight - scrollTop - clientHeight < 200) {
            this.props.onScrollEvent(event);
        }
    };

    private onChangeScrollDebounce = debounce(this.onChangeScroll, 250);

    render() {
        return this.props.children;
    }
}

export interface IInfinityScrollWrapperProps {
    hasMore: boolean;
    isLoading?: boolean;
    sizeElement: RefObject<any>;
    watchElement?: RefObject<any>;
    watchDocumentBody?: boolean;
    onScrollEvent: (event: ChangeEvent) => void;
}

export default InfinityScrollWrapper;
